// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__aTCQb","icon":"NotFound_icon__4Fsgz","homeBtn":"NotFound_homeBtn__qaz8O"};